import React from "react";
import style from './FooterNew.module.css'; 
import {Link} from 'react-router-dom';
import { FaInstagram } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";

function FooterNew(){

    return(
        <div className={style.FooterNew_container}>

            {/* <section> */}
            {/* <p>© 2025 NuFolks<br />All rights reserved</p> */}
            <div className={style.copyright_container}>
                <span>© 2025 NuFolks</span>
                <span className={`${style.seperator}`}>|</span>
                <span>All rights reserved</span>
            </div>
            <div className={style.Link_container}>
                <Link to='/privacy-policy' className={style.Link_common}>Privacy Policy</Link>
                <span className={`${style.seperator} ${style.Link_common}`}>|</span>
                <Link to='/terms-and-conditions' className={style.Link_common}>Terms & Conditions</Link>
            </div>
            {/* </section> */}
            <div className={style.socialMedia_container}>
                <a
                    // className={`${style.social_icon} ${style.instagram}`}
                    className={style.socialMedia_icon_common}
                    href="https://www.instagram.com/nufolks/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <FaInstagram />
                </a>
                <a
                    // className={`${style.social_icon} ${style.facebook}`}
                    className={style.socialMedia_icon_common}
                    href="https://www.facebook.com/profile.php?id=100093030851094"
                    target="_blank"
                    rel="noopener noreferrer">
                    <FaFacebookF />
                </a>
                <a
                    // className={`${style.social_icon} ${style.twitter}`}
                    className={style.socialMedia_icon_common}
                    href="https://twitter.com/TheNuFolks"
                    target="_blank"
                    rel="noopener noreferrer">
                    <FaTwitter />
                </a>
                <a
                    // className={`${style.social_icon} ${style.linkedin}`}
                    className={style.socialMedia_icon_common}
                    href="https://in.linkedin.com/company/nufolks"
                    target="_blank"
                    rel="noopener noreferrer">
                    <FaLinkedinIn />
                </a>
                <a
                    // className={`${style.social_icon} ${style.linkedin}`}
                    className={style.socialMedia_icon_common}
                    href="https://www.youtube.com/@NuFolks" // check
                    target="_blank"
                    rel="noopener noreferrer">
                    <FaYoutube />
                </a>
            </div>
        </div>
    );
}

export default FooterNew;   